(() => {
  const initHomepage = (root) => {
    if (!(root instanceof HTMLElement) || root.dataset.popHomepageReady === 'true') return;
    root.dataset.popHomepageReady = 'true';

    const scroller = root.querySelector('[data-pop-style-scroller]');
    const dots = Array.from(root.querySelectorAll('[data-pop-style-dot]'));
    const cards = scroller ? Array.from(scroller.querySelectorAll('.pop-home-v2__style-card')) : [];
    if (!scroller || !dots.length || !cards.length) return;

    const setActiveDot = (index) => {
      dots.forEach((dot, dotIndex) => {
        if (dotIndex === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    const updateActiveDot = () => {
      if (window.matchMedia('(min-width: 1100px)').matches) {
        setActiveDot(0);
        return;
      }

      const scrollerLeft = scroller.getBoundingClientRect().left;
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;
      cards.forEach((card, index) => {
        const distance = Math.abs(card.getBoundingClientRect().left - scrollerLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });
      setActiveDot(closestIndex);
    };

    let frame = 0;
    scroller.addEventListener(
      'scroll',
      () => {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(updateActiveDot);
      },
      { passive: true }
    );

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        const card = cards[index];
        if (!card) return;
        scroller.scrollTo({
          left: card.offsetLeft - scroller.offsetLeft,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      });
    });

    updateActiveDot();
  };

  const initAll = () => {
    document.querySelectorAll('[data-pop-home-v2]').forEach(initHomepage);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-pop-home-v2]');
    if (root) initHomepage(root);
  });
})();
